import { ServiceError } from "../../../service/Shared";

export const hasFieldError = (errors: ServiceError[] | undefined, property: string): boolean =>
  !!errors?.some((error) => error.property?.toLowerCase() === property.toLowerCase());

export const getErrorMessages = (errors: ServiceError[] | undefined): string[] =>
  errors?.map((error) => error.message) ?? [];
